<template>
    <div class="flex justify-center min-w-[320px] m-auto md:max-w-[80%]">
        <div
            :class="[
                !isShowingDiscussion && screen.minMD ? 'flex justify-center' : '',
                'document-xandr-banner-wrapper',
            ]"
        >
            <Xandr
                v-resize="throttleAdResize"
                v-bind="xandrProperties"
            ></Xandr>
        </div>
    </div>
</template>

<script>
import { Xandr } from '@components/Xandr';
import { mapGetters } from 'vuex';
import { throttle } from 'lodash-es';
import { handleAdResize } from '@/modules/xandr';

export default {
    name: 'DocumentShowXandrAds',
    components: {
        Xandr,
    },
    props: {
        xandrProperties: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            throttleAdResize: null,
        };
    },
    computed: {
        ...mapGetters({
            isShowingDiscussion: 'document/isShowingDiscussion',
            screen: 'ui/screen',
            xandrData: 'xandr/xandrAdData',
        }),
    },
    created() {
        this.throttleAdResize = throttle(handleAdResize, 300);
    },
};
</script>

<style lang="scss" scoped>
.document-xandr-banner-wrapper {
    width: 100%;
    max-width: 728px;
}
</style>
